<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;

	.sclectlable {
		margin-right: 20px;
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #f7f7f7;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	// button:last-child {
	// 	background-color: #ff8300;
	// }

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		background-color: #f41127;
	}
}

.addstras {
	.addstrastitle {
		margin-bottom: 30px;
	}
}
</style>
<template>
	<div>
		<!-- <div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.pro_guid" clearable placeholder="请选择专业" @change="getpolist()">
						<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div><el-input placeholder="请输入训练策略" v-model="pagesobj.sm_title" clearable></el-input></div>
			</div>
			<div class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div> -->
		<div class="resourbtn"><el-button @click.stop="addsours" type="primary" size="small" icon="fa fa-plus">添加内容</el-button></div>

		<el-tabs type="border-card" @tab-click="changetabs">
			<el-tab-pane label="实训室">
				<div class="tables">
					<div class="tabslist">
						<div class="paginations">
							每页显示
							<input @change="changetablesize" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
							行
						</div>
						<div class="tabslis">
							<template>
								<el-table
									:data="tableData"
									ref="multipleTables"
									@selection-change="handleSelectionChangetrain"
									header-row-class-name="tablestitle"
									border
									style="width: 100%"
								>
									<el-table-column type="selection" width="55"></el-table-column>
									<el-table-column label="实训室名称" prop="tr_name"></el-table-column>
									<el-table-column label="所属学校" prop="SchoolInfo.si_name_cn"></el-table-column>
								</el-table>
							</template>
						</div>
						<div class="tabsnum">
							<p>
								显示
								<span>1</span>
								到
								<span>{{ pagesobj.pageSize }}</span>
								,共
								<span>{{ totalall }}</span>
								条记录
							</p>
							<div class="elpagian">
								<el-pagination
									@current-change="changecurr"
									background
									layout="prev, pager, next"
									:page-size="pagesobj.pageSize"
									:total="totalall"
									:current-page="pagesobj.pageIndex"
								></el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="实训设备">
				<div class="tables">
					<div class="tabslist">
						<div class="paginations">
							每页显示
							<input @change="changetablesize" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
							行
						</div>
						<div class="tabslis">
							<template>
								<el-table
									:data="tableData"
									ref="multipleTable"
									@selection-change="handleSelectionChange"
									header-row-class-name="tablestitle"
									border
									style="width: 100%"
								>
									<el-table-column type="selection" width="55"></el-table-column>
									<el-table-column label="实训设备名称" prop="sx_tr_name"></el-table-column>
									<el-table-column label="所属学校" prop="si_name"></el-table-column>
								</el-table>
							</template>
						</div>
						<div class="tabsnum">
							<p>
								显示
								<span>1</span>
								到
								<span>{{ pagesobj.pageSize }}</span>
								,共
								<span>{{ totalall }}</span>
								条记录
							</p>
							<div class="elpagian">
								<el-pagination
									@current-change="changecurr"
									background
									layout="prev, pager, next"
									:page-size="pagesobj.pageSize"
									:total="totalall"
									:current-page="pagesobj.pageIndex"
								></el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { getTrainRoom, GetTrainingStrategyList, getGetProfList, getPositionList, changeGradeGet, getGetResourceTypes } from '@/request/api/homesview/yunhomes/yunhom.js';
// import { stringify } from 'qs';

import { getPageTrainEquipmentList } from '@/request/api/trainroom/trainroom.js';

export default {
	props: {
		chioceid: String
	},
	data() {
		return {
			dialogVisibles: false,
			dialogVisible: false,
			// 标题
			paths: [
				{
					path: '/homesview/testists/questionbank',
					name: '训练策略'
				}
			],
			totalall: 0,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				sm_title: '',
				smt_guid: '',
				PR_GUID: '',
				PCR_RuleTitle: '',
				IL_GUID: '',
				pro_guid: '',
				PCT_IsState: '',
				tr_name: '',
				si_guid: '',
				sx_tr_guid: '',
				te_deviceName: ''
			},
			// localStorage.getItem("siguid")
			tabsnun: 10,
			tableData: [],
			// 获取专业、岗位、资源类型列表
			rtlist: [],
			prolist: [],
			polist: [],
			rtlist: [],
			gradeget: [],
			singleCount: false,
			multiCount: false,
			judgeCount: false,
			singleScoreall: 0,
			multiScoreall: 0,
			judgeScoresall: 0,
			// 选择单选信息
			selectionobj: {},
			issxactive: 0
		};
	},
	mounted() {
		this.get();
	},
	methods: {
		// 更改实训室实训设备
		changetabs(val) {
			// console.log(val.label,"更改")
			this.pagesobj.pageIndex = 1;
			this.pagesobj.pageSize = 10;
			this.tabsnun = 10;
			if (val.label == '实训设备') {
				this.issxactive = 1;
			} else {
				this.issxactive = 0;
			}

			this.getresours();
		},
		changetablesize() {
			// console.log(val,"index")
			this.pagesobj.pageSize = this.tabsnun;
			this.getresours();
		},

		handleSelectionChangetrain(val) {
			// console.log(val)
			if (val.length > 1) {
				this.$refs.multipleTables.clearSelection();
				this.$refs.multipleTables.toggleRowSelection(val.pop());
			}
			this.selectionobj = val[0];
		},
		handleSelectionChange(val) {
			if (val.length > 1) {
				this.$refs.multipleTable.clearSelection();
				this.$refs.multipleTable.toggleRowSelection(val.pop());
			}
			this.selectionobj = val[0];
		},
		// 添加策略
		addsours() {
			// console.log(this.selectionobj)
			this.selectionobj.isactives = this.issxactive;
			if (this.issxactive == 0) {
				if (this.selectionobj.sx_tr_guid) {
					this.$emit('coust-change', JSON.stringify(this.selectionobj));
				} else {
					this.$message('请选择策略');
				}
			} else {
				if (this.selectionobj.sx_te_guid) {
					this.$emit('coust-change', JSON.stringify(this.selectionobj));
				} else {
					this.$message('请选择策略');
				}
			}
		},

		getprolist() {
			getGetProfList().then(res => {
				// console.log(res.data.data)
				if (res.data.code > 0) {
					this.prolist = res.data.data;
					if (this.pagesobj.pro_guid !== '') {
						this.getpolist();
					}
				}
			});
		},
		getpolist() {
			getPositionList(this.pagesobj.pro_guid).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},

		indexMethod(index) {
			return index + 1;
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.getresours();
		},
		get() {
			this.getresours();
			this.getprolist();
			this.getgrads();
			// console.log("请求")
		},
		getgrads() {
			changeGradeGet().then(res => {
				// console.log("获取等级",res)
				this.gradeget = res.data.data;
			});
		},

		getResourceType() {
			getGetResourceTypes().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
				}
			});
		},
		getresours() {
			if (this.issxactive == 0) {
				getTrainRoom(this.pagesobj).then(res => {
					if (res.data.code > 0) {
						// console.log(res)
						this.tableData = res.data.data.list;
						this.totalall = res.data.data.totalCount;

						if (this.tableData.length > 0) {
							this.$nextTick(() => {
								this.tableData.forEach((item, index) => {
									if (item.sx_tr_guid == this.chioceid) {
										console.log('所有aaaaa', this.chioceid);
										this.$refs.multipleTables.toggleRowSelection(item, true);
									}
								});
							});
						}
					}
				});
			} else {
				getPageTrainEquipmentList(this.pagesobj).then(res => {
					if (res.data.code > 0) {
						// console.log(res)
						this.tableData = res.data.data.list;
						this.totalall = res.data.data.totalCount;

						if (this.tableData.length > 0) {
							this.$nextTick(() => {
								this.tableData.forEach((item, index) => {
									if (item.sx_te_guid == this.chioceid) {
										console.log('所有bbb', this.chioceid);
										this.$refs.multipleTable.toggleRowSelection(item, true);
									}
								});
							});
						}
					}
				});
			}
		}
	}
};
</script>
